<template>
  <div :class="{ 'has-logo': showLogo }">
    <!-- logo-->
    <logo :collapse="isCollapse" />
    <!-- 导航滚轮-->
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <!-- 导航菜单-->
      <el-menu
        :active-text-color="variables.menuActiveText"
        :background-color="variables.menuBg"
        :collapse="isCollapse"
        :collapse-transition="false"
        :default-active="activeMenu"
        :text-color="variables.menuText"
        :unique-opened="true"
      >
        <!--        下级菜单-->
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :base-path="route.path"
          :item="route"
          :isCollapse="isCollapse"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import variables from "@/styles/variables.scss";
import { mapGetters } from "vuex";
import Logo from "./Sidebar/Logo";
import SidebarItem from "./Sidebar/SidebarItem";

export default {
  components: { SidebarItem, Logo },
  methods: {},
  computed: {
    ...mapGetters(["sidebar", "info"]),
    routes() { 
      console.log(this.$router.options.routes);
      let router = [...this.$router.options.routes];
      if (this.info.pid !== 0) {
        if (router[9].children.length !== 1) {
          router[9].children.splice(0, 1);
          router[9].children[0].meta.icon = "el-icon-s-goods";
        }
      }
      if (router[4].children.length !== 4) {
        router[4].children.splice(6, 1);
      }
      return router;
    },
    activeMenu() {
      //默认菜单
      const route = this.$route;
      const { meta, path } = route;
      // 如果设置路径，侧栏将突出显示您设置的路径
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      //是显示 logo
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      // 导航菜单值
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
};
</script>
